import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/404'),
		hidden: true
	},
	{
		path: '',
		component: Layout,
		redirect: '/home',
		children: [{
			path: 'home',
			name: 'home',
			component: () => import('@/views/home/index'),
			meta: {
				title: '首页',
				icon: 'home'
			}
		}]
	}
]

export const asyncRouterMap = [{
		path: '/pms',
		component: Layout,
		redirect: '/pms/product',
		name: 'pms',
		meta: {
			title: '商品',
			icon: 'product'
		},
		children: [{
				path: 'product',
				name: 'product',
				component: () => import('@/views/pms/product/index'),
				meta: {
					keepAlive: true,
					title: '商品列表',
					icon: 'product-list'
				}
			},
			{
				path: 'addProduct',
				name: 'addProduct',
				component: () => import('@/views/pms/product/add'),
				meta: {
					title: '添加商品',
					icon: 'product-add'
				}
			},
			{
				path: 'updateProduct',
				name: 'updateProduct',
				component: () => import('@/views/pms/product/update'),
				meta: {
					title: '修改商品',
					icon: 'product-add'
				},
				hidden: true
			},
			{
				path: 'productCate',
				name: 'productCate',
				component: () => import('@/views/pms/productCate/index'),
				meta: {
					title: '商品分类',
					icon: 'product-cate'
				}
			},
			{
				path: 'addProductCate',
				name: 'addProductCate',
				component: () => import('@/views/pms/productCate/add'),
				meta: {
					title: '添加商品分类'
				},
				hidden: true
			},
			{
				path: 'updateProductCate',
				name: 'updateProductCate',
				component: () => import('@/views/pms/productCate/update'),
				meta: {
					title: '修改商品分类'
				},
				hidden: true
			},
			{
				path: 'productAttr',
				name: 'productAttr',
				component: () => import('@/views/pms/productAttr/index'),
				meta: {
					title: '商品类型',
					icon: 'product-attr'
				}
			},
			{
				path: 'productAttrList',
				name: 'productAttrList',
				component: () => import('@/views/pms/productAttr/productAttrList'),
				meta: {
					title: '商品属性列表'
				},
				hidden: true
			},
			{
				path: 'addProductAttr',
				name: 'addProductAttr',
				component: () => import('@/views/pms/productAttr/addProductAttr'),
				meta: {
					title: '添加商品属性'
				},
				hidden: true
			},
			{
				path: 'updateProductAttr',
				name: 'updateProductAttr',
				component: () => import('@/views/pms/productAttr/updateProductAttr'),
				meta: {
					title: '修改商品属性'
				},
				hidden: true
			},
			{
				path: 'brand',
				name: 'brand',
				component: () => import('@/views/pms/brand/index'),
				meta: {
					title: '品牌管理',
					icon: 'product-brand'
				}
			},
			{
				path: 'addBrand',
				name: 'addBrand',
				component: () => import('@/views/pms/brand/add'),
				meta: {
					title: '添加品牌'
				},
				hidden: true
			},
			{
				path: 'updateBrand',
				name: 'updateBrand',
				component: () => import('@/views/pms/brand/update'),
				meta: {
					title: '编辑品牌'
				},
				hidden: true
			},
			{
				path: 'freight',
				name: 'freight',
				component: () => import('@/views/pms/freight/index'),
				meta: {
					title: '运费模板',
					icon: 'product-list'
				}
			},
			{
				path: 'physical',
				name: 'physical',
				component: () => import('@/views/pms/physical/index'),
				meta: {
					title: '实体商品管理',
					icon: 'product-list'
				}
			},
			{
				path: 'officeLine',
				name: 'officeLine',
				component: () => import('@/views/pms/productCateOfficeLine/index'),
				meta: {
					title: '实体商品分类',
					icon: 'product-cate'
				}
			},
			{
				path: 'addProductCateOfficeLine',
				name: 'addProductCateOfficeLine',
				component: () => import('@/views/pms/productCateOfficeLine/add'),
				meta: {
					title: '添加实体商品分类'
				},
				hidden: true
			},
			{
				path: 'updateProductCateOfficeLine',
				name: 'updateProductCateOfficeLine',
				component: () => import('@/views/pms/productCateOfficeLine/update'),
				meta: {
					title: '修改实体商品分类'
				},
				hidden: true
			},
		]
	},
	{
		path: '/oms',
		component: Layout,
		redirect: '/oms/order',
		name: 'oms',
		meta: {
			title: '订单',
			icon: 'order'
		},
		children: [{
				path: 'order',
				name: 'order',
				component: () => import('@/views/oms/order/index'),
				meta: {
					keepAlive: true,
					title: '订单列表',
					icon: 'product-list'
				}
			},
			{
				path: 'orderDetail',
				name: 'orderDetail',
				component: () => import('@/views/oms/order/orderDetail'),
				meta: {
					title: '订单详情'
				},
				hidden: true
			},

			{
				path: 'deliverOrderList',
				name: 'deliverOrderList',
				component: () => import('@/views/oms/order/deliverOrderList'),
				meta: {
					title: '发货列表'
				},
				hidden: true
			},
			{
				path: 'orderSetting',
				name: 'orderSetting',
				component: () => import('@/views/oms/order/setting'),
				meta: {
					title: '订单设置',
					icon: 'order-setting'
				}
			},
			{
				path: 'orderConfig',
				name: 'orderConfig',
				component: () => import('@/views/sys/orderConfig/index'),
				meta: {
					title: '下单策略',
					icon: 'product-list'
				}
			},
			{
				path: 'refund',
				name: 'refund',
				component: () => import('@/views/oms/refund/index'),
				meta: {
					title: '退款管理',
					icon: 'order-return'
				}
			},
			{
				path: 'refundHandle',
				name: 'refundHandle',
				component: () => import('@/views/oms/refund/handle'),
				meta: {
					title: '处理退款'
				},
				hidden: true
			},
			{
				path: 'returnApply',
				name: 'returnApply',
				component: () => import('@/views/oms/apply/index'),
				meta: {
					title: '退货申请处理',
					icon: 'order-return'
				}
			},
			{
				path: 'returnReason',
				name: 'returnReason',
				component: () => import('@/views/oms/apply/reason'),
				meta: {
					title: '退货原因设置',
					icon: 'order-return-reason'
				}
			},
			{
				path: 'returnApplyDetail',
				name: 'returnApplyDetail',
				component: () => import('@/views/oms/apply/applyDetail'),
				meta: {
					title: '退货原因详情'
				},
				hidden: true
			},
			{
				path: 'entityOrder',
				name: 'entityOrder',
				component: () => import('@/views/oms/entityOrder/index'),
				meta: {
					title: '实体订单列表'
				}
			},
			{
				path: 'entityorderDetail',
				name: 'entityorderDetail',
				component: () => import('@/views/oms/entityOrder/orderDetail'),
				meta: {
					title: '实体订单详情'
				},
				hidden: true
			},
		]
	},
	{
		path: '/sms',
		component: Layout,
		redirect: '/sms/coupon',
		name: 'sms',
		meta: {
			title: '营销',
			icon: 'sms'
		},
		children: [{
				path: 'flash',
				name: 'flash',
				component: () => import('@/views/sms/flash/index'),
				meta: {
					title: '秒杀活动列表',
					icon: 'sms-flash'
				}
			},
			{
				path: 'flashSession',
				name: 'flashSession',
				component: () => import('@/views/sms/flash/sessionList'),
				meta: {
					title: '秒杀时间段列表'
				},
				hidden: true
			},
			{
				path: 'selectSession',
				name: 'selectSession',
				component: () => import('@/views/sms/flash/selectSessionList'),
				meta: {
					title: '秒杀时间段选择'
				},
				hidden: true
			},
			{
				path: 'flashProductRelation',
				name: 'flashProductRelation',
				component: () => import('@/views/sms/flash/productRelationList'),
				meta: {
					title: '秒杀商品列表'
				},
				hidden: true
			},
			{
				path: 'coupon',
				name: 'coupon',
				component: () => import('@/views/sms/coupon/index'),
				meta: {
					title: '优惠券列表',
					icon: 'sms-coupon'
				}
			},
			{
				path: 'addCoupon',
				name: 'addCoupon',
				component: () => import('@/views/sms/coupon/add'),
				meta: {
					title: '添加优惠券'
				},
				hidden: true
			},
			{
				path: 'updateCoupon',
				name: 'updateCoupon',
				component: () => import('@/views/sms/coupon/update'),
				meta: {
					title: '修改优惠券'
				},
				hidden: true
			},
			{
				path: 'couponHistory',
				name: 'couponHistory',
				component: () => import('@/views/sms/coupon/history'),
				meta: {
					title: '优惠券领取详情'
				},
				hidden: true
			},
			{
				path: 'brand',
				name: 'homeBrand',
				component: () => import('@/views/sms/brand/index'),
				meta: {
					title: '品牌推荐',
					icon: 'product-brand'
				}
			},
			{
				path: 'new',
				name: 'homeNew',
				component: () => import('@/views/sms/new/index'),
				meta: {
					title: '新品推荐',
					icon: 'sms-new'
				}
			},
			{
				path: 'hot',
				name: 'homeHot',
				component: () => import('@/views/sms/hot/index'),
				meta: {
					title: '商务专区',
					icon: 'sms-hot'
				}
			},
			{
				path: 'warehouse',
				name: 'warehouse',
				component: () => import('@/views/sms/warehouse/index'),
				meta: {
					title: '12库商品',
					icon: 'sms-hot'
				}
			},
			{
				path: 'points',
				name: 'points',
				component: () => import('@/views/sms/points/index'),
				meta: {
					title: '券兑换',
					icon: 'sms-hot'
				}
			},
			{
				path: 'welfare',
				name: 'welfare',
				component: () => import('@/views/sms/welfare/index'),
				meta: {
					title: '福利区',
					icon: 'sms-hot'
				}
			},
			{
				path: 'sale',
				name: 'sale',
				component: () => import('@/views/sms/sale/index'),
				meta: {
					title: '特价区',
					icon: 'sms-hot'
				}
			},
			{
				path: 'consumption',
				name: 'consumption',
				component: () => import('@/views/sms/consumption/index'),
				meta: {
					title: '券消费',
					icon: 'sms-hot'
				}
			},
			{
				path: 'subject',
				name: 'homeSubject',
				component: () => import('@/views/sms/subject/index'),
				meta: {
					title: '专题推荐',
					icon: 'sms-subject'
				}
			},
			{
				path: 'advertise',
				name: 'homeAdvertise',
				component: () => import('@/views/sms/advertise/index'),
				meta: {
					title: '广告列表',
					icon: 'sms-ad'
				}
			},
			{
				path: 'notice',
				name: 'notice',
				component: () => import('@/views/sms/notice/index'),
				meta: {
					title: '公告管理',
					icon: 'sms-ad'
				}
			},
			{
				path: 'addAdvertise',
				name: 'addHomeAdvertise',
				component: () => import('@/views/sms/advertise/add'),
				meta: {
					title: '添加广告'
				},
				hidden: true
			},
			{
				path: 'updateAdvertise',
				name: 'updateHomeAdvertise',
				component: () => import('@/views/sms/advertise/update'),
				meta: {
					title: '编辑广告'
				},
				hidden: true
			}
		]
	},
	{
		path: '/ums',
		component: Layout,
		redirect: '/ums/member',
		name: 'ums',
		meta: {
			title: '会员',
			icon: 'vip'
		},
		alwaysShow: true,
		children: [{
				path: 'member',
				name: 'member',
				component: () => import('@/views/ums/member/index'),
				meta: {
					title: '会员列表',
					icon: 'product-list'
				}
			},
			{
				path: 'memberLevel',
				name: 'memberLevel',
				component: () => import('@/views/ums/memberLevel/index'),
				meta: {
					title: '会员等级列表',
					icon: 'product-list'
				}
			},
			{
				path: 'distribution',
				name: 'distribution',
				component: () => import('@/views/ums/distribution/index'),
				meta: {
					title: '分销管理',
					icon: 'product-list'
				}
			},
			{
				path: 'addMemberLevel',
				name: 'addMemberLevel',
				component: () => import('@/views/ums/memberLevel/add'),
				meta: {
					title: '添加会员等级'
				},
				hidden: true
			},
			{
				path: 'updateMemberLevel',
				name: 'updateMemberLevel',
				component: () => import('@/views/ums/memberLevel/update'),
				meta: {
					title: '编辑会员等级'
				},
				hidden: true
			},
			{
				path: 'historyMemberLevel',
				name: 'historyMemberLevel',
				component: () => import('@/views/ums/memberLevel/history'),
				meta: {
					title: '会员等级详情'
				},
				hidden: true
			}

		]
	},
	{
		path: '/sys',
		component: Layout,
		redirect: '/sys/admin',
		name: 'sys',
		meta: {
			title: '系统设置',
			icon: 'ums'
		},
		children: [{
				path: 'dividendManage',
				name: 'dividendManage',
				component: () => import('@/views/sys/dividendManage/index'),
				meta: {
					title: '分红管理',
					icon: 'product-list'
				}
			}, {
				path: 'dividendDetail',
				name: 'dividendDetail',
				component: () => import('@/views/sys/dividendManage/detail'),
				meta: {
					title: '分红明细',
					icon: 'product-list'
				},
				hidden: true
			}, {
				path: 'performanceSet',
				name: 'performanceSet',
				component: () => import('@/views/sys/performanceSet/index'),
				meta: {
					title: '新增业绩设置',
					icon: 'product-list'
				}
			},
			{
				path: 'openlibraryInfo',
				name: 'openlibraryInfo',
				component: () => import('@/views/sys/openlibraryInfo/index'),
				meta: {
					title: '开库信息',
					icon: 'product-list'
				}
			},
			{
				path: 'admin',
				name: 'admin',
				component: () => import('@/views/sys/admin/index'),
				meta: {
					title: '用户列表',
					icon: 'ums-admin'
				}
			},
			{
				path: 'role',
				name: 'role',
				component: () => import('@/views/sys/role/index'),
				meta: {
					title: '角色列表',
					icon: 'ums-role'
				}
			},
			{
				path: 'allocMenu',
				name: 'allocMenu',
				component: () => import('@/views/sys/role/allocMenu'),
				meta: {
					title: '分配菜单'
				},
				hidden: true
			},
			{
				path: 'allocResource',
				name: 'allocResource',
				component: () => import('@/views/sys/role/allocResource'),
				meta: {
					title: '分配资源'
				},
				hidden: true
			},
			{
				path: 'menu',
				name: 'menu',
				component: () => import('@/views/sys/menu/index'),
				meta: {
					title: '菜单列表',
					icon: 'ums-menu'
				}
			},
			{
				path: 'addMenu',
				name: 'addMenu',
				component: () => import('@/views/sys/menu/add'),
				meta: {
					title: '添加菜单'
				},
				hidden: true
			},
			{
				path: 'updateMenu',
				name: 'updateMenu',
				component: () => import('@/views/sys/menu/update'),
				meta: {
					title: '修改菜单'
				},
				hidden: true
			},
			{
				path: 'resource',
				name: 'resource',
				component: () => import('@/views/sys/resource/index'),
				meta: {
					title: '资源列表',
					icon: 'ums-resource'
				}
			},
			{
				path: 'resourceCategory',
				name: 'resourceCategory',
				component: () => import('@/views/sys/resource/categoryList'),
				meta: {
					title: '资源分类'
				},
				hidden: true
			},
			{
				path: 'config',
				name: 'config',
				component: () => import('@/views/sys/config/index'),
				meta: {
					title: '系统参数列表',
					icon: 'ums'
				}
			},
			{
				path: 'report',
				name: 'report',
				component: () => import('@/views/sys/report/index'),
				meta: {
					title: '字典管理',
					icon: 'ums'
				}
			},
			{
				path: 'reportValue',
				name: 'reportValue',
				component: () => import('@/views/sys/report/reportValue'),
				meta: {
					title: '字典明细'
				},
				hidden: true
			},
			{
				path: 'reporting',
				name: 'reporting',
				component: () => import('@/views/sys/reporting/index'),
				meta: {
					title: '举报管理',
					icon: 'ums'
				}
			},
			{
				path: 'opinion',
				name: 'opinion',
				component: () => import('@/views/sys/opinion/index'),
				meta: {
					title: '意见反馈',
					icon: 'ums'
				}
			},
			{
				path: 'bonusPoints',
				name: 'bonusPoints',
				component: () => import('@/views/sys/bonusPoints/index'),
				meta: {
					title: '赠送购物券管理',
					icon: 'product-list'
				}
			},
			{
				path: 'words',
				name: 'words',
				component: () => import('@/views/sys/words/index'),
				meta: {
					title: '敏感词管理',
					icon: 'product-list'
				}
			},
			{
				path: 'region',
				name: 'region',
				component: () => import('@/views/sys/region/index'),
				meta: {
					title: '行政区',
					icon: 'product-list'
				}
			},
			{
				path: 'address',
				name: 'address',
				component: () => import('@/views/mms/address/index'),
				meta: {
					title: '商家地址管理',
					icon: 'product-list'
				}
			},
		]
	}, {
		path: '/bms',
		component: Layout,
		redirect: '/bms/school',
		name: 'bms',
		meta: {
			title: '商学院',
			icon: 'product'
		},
		children: [{
				path: 'classification',
				name: 'classification',
				component: () => import('@/views/bms/school/index'),
				meta: {
					title: '课程分类',
					icon: 'product-list'
				}
			},
			{
				path: 'school',
				name: 'school',
				component: () => import('@/views/bms/school/school'),
				meta: {
					title: '课程列表',
					icon: 'product-list'
				}
			},
		]
	}, {
		path: '/mms',
		component: Layout,
		redirect: '/mms/merchant',
		name: 'mms',
		meta: {
			title: '商家管理',
			icon: 'product'
		},
		children: [{
				path: 'merchant',
				name: 'merchant',
				component: () => import('@/views/mms/merchant/index'),
				meta: {
					title: '商家列表',
					icon: 'product-list'
				}
			},
			{
				path: 'examine',
				name: 'examine',
				component: () => import('@/views/mms/examine/index'),
				meta: {
					title: '商家信息审核管理',
					icon: 'product-list'
				}
			},

			{
				path: 'withdrawal',
				name: 'withdrawal',
				component: () => import('@/views/mms/withdrawal/index'),
				meta: {
					title: '提现管理',
					icon: 'product-list'
				}
			},

		]
	}, {
		path: '/xms',
		component: Layout,
		redirect: '/xms/zhoule',
		name: 'xms',
		meta: {
			title: '盲盒管理',
			icon: 'sms'
		},
		children: [{
				path: 'zhoule',
				name: 'zhoule',
				component: () => import('@/views/xms/zhoule/index'),
				meta: {
					title: '盲盒周周乐',
					icon: 'product-list'
				}
			},
			{
				path: 'zhouStatistics',
				name: 'zhouStatistics',
				component: () => import('@/views/xms/zhouStatistics/index'),
				meta: {
					title: '盲盒周周乐统计',
					icon: 'product-list'
				}
			},
			{
				path: 'pay',
				name: 'pay',
				component: () => import('@/views/xms/pay/index'),
				meta: {
					title: '付费盲盒',
					icon: 'product-list'
				}
			},
			{
				path: 'payStatistics',
				name: 'payStatistics',
				component: () => import('@/views/xms/payStatistics/index'),
				meta: {
					title: '付费盲盒',
					icon: 'product-list'
				}
			},
		]
	}, {
		path: '/tms',
		component: Layout,
		redirect: '/tms/platform',
		name: 'tms',
		meta: {
			title: '统计查询',
			icon: 'sms'
		},
		children: [{
				path: 'twelvePerformance',
				name: 'twelvePerformance',
				component: () => import('@/views/tms/twelvePerformance/index'),
				meta: {
					title: '十二库业绩统计',
					icon: 'product-list'
				}
			},
			{
				path: 'platform',
				name: 'platform',
				component: () => import('@/views/tms/platform/index'),
				meta: {
					title: '发放权益统计',
					icon: 'product-list'
				}
			},
			{
				path: 'release',
				name: 'release',
				component: () => import('@/views/tms/release/index'),
				meta: {
					title: '券补贴统计',
					icon: 'product-list'
				}
			},
			{
				path: 'orderStatistics',
				name: 'orderStatistics',
				component: () => import('@/views/tms/orderStatistics/index'),
				meta: {
					title: '订单统计',
					icon: 'product-list'
				}
			},
			{
				path: 'manager',
				name: 'manager',
				component: () => import('@/views/tms/manager/index'),
				meta: {
					title: '大区经理统计',
					icon: 'product-list'
				}
			},
			{
				path: 'investment',
				name: 'investment',
				component: () => import('@/views/tms/investment/index'),
				meta: {
					title: '消费招商统计',
					icon: 'product-list'
				}
			},
			{
				path: 'agent',
				name: 'agent',
				component: () => import('@/views/tms/agent/index'),
				meta: {
					title: '区域代理统计',
					icon: 'product-list'
				}
			},
			{
				path: 'releasePoints',
				name: 'releasePoints',
				component: () => import('@/views/tms/releasePoints/index'),
				meta: {
					title: '券每日补贴统计',
					icon: 'product-list'
				}
			}
		]
	}, {
		path: '*',
		redirect: '/404',
		hidden: true
	}
]

export default new Router({
	// mode: 'history', //后端支持可开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js